import React from 'react';
import { Button } from './ui/button';
import { FileText, MessageSquare } from 'lucide-react';

export const CTASection = () => {
  return (
    <section className="py-20 bg-blue-900 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            size="lg"
            variant="outline"
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-900 px-8 py-6 text-lg font-semibold transition-all duration-300">

            Contact RHE Project Consulting
            <MessageSquare className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>);

};